export * from "-!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--4-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--4-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/lib/index.js??ref--4-3!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SidebarItem.vue?vue&type=style&index=0&id=96fcd4f2&prod&langs=scss&scoped=true&lang=css"


//////////////////
// WEBPACK FOOTER
// ./src/components/SidebarPlugin/SidebarItem.vue?vue&type=style&index=0&id=96fcd4f2&prod&langs=scss&scoped=true&lang=css
// module id = 1462
// module chunks = 31